import { GameConstants } from "./../../GameConstants";
import { GameVars } from "./../../GameVars";

// saber que cartas ya han salido y descartarlas
// saber en todo momento que cartas tienen los demas jugadores y cuantas se saben

export class AI {

    private id: number;
    private adveresaries: {id: number, cards: CardValue[], isRigth: boolean}[];

    public init(id: number): void {

        this.id = id;
    }

    public reset(): void {

        this.adveresaries = [];

        let nextIsRigth = false;

        for (let i = 0; i < GameVars.players.length; i++) {

            if (this.id === i) {
                nextIsRigth = true;
                continue;
            }

            if (GameVars.players[i].tokens > 0) {
                this.adveresaries.push({id: i, cards: [], isRigth: nextIsRigth});

                if (nextIsRigth) {
                    nextIsRigth = false;
                }
            }
        }

        if (nextIsRigth) {
            this.adveresaries[0].isRigth = true;
        }
    }

    public addCardToPlayer(cardValue: CardValue, id: number): void {

        for (let i = 0; i < this.adveresaries.length; i++) {
            if (id === this.adveresaries[i].id) {
                this.adveresaries[i].cards.push(cardValue);
            }
        }
    }

    public removeCardToPlayer(cardValue: CardValue, id: number): void {

        for (let i = 0; i < this.adveresaries.length; i++) {
            if (id === this.adveresaries[i].id) {
                if (this.adveresaries[i].cards.indexOf(cardValue) !== -1) {
                    this.adveresaries[i].cards.splice(this.adveresaries[i].cards.indexOf(cardValue), 1);
                }
            }
        }
    }

    public selectDeckOrWasteAI(): string {

        let result = this.getPointsAndSuit();

        if (GameVars.topCardWaste.suit === result.suit && this.valueToNumber(GameVars.topCardWaste.value) >= 7) {
            return "waste";
        } else {
            return "deck";
        }
    }

    public selectCardAndStopAI(): {card: number, stop: boolean} {

        let points = [0,  0, 0, 0];
        let cards = GameVars.players[this.id].cards;

        for (let i = 0; i < cards.length; i++) {
            points[cards[i].suit] += this.valueToNumber(cards[i].value);
        }

        // miramos que suit tiene mas puntos
        let maxPoints = points[0];
        let maxSuit = 0;
        for (let i = 1; i < points.length; i++) {
            if (points[i] > maxPoints) {
                maxPoints = points[i];
                maxSuit = i;
            }
        }

        let rightMaxSuit = maxSuit;

        if (GameVars.difficulty === GameConstants.DIFFICULTY_EXPERT) {
            for (let i = 0; i < this.adveresaries.length; i++) {
                if (this.adveresaries[i].isRigth) {

                    let rightPoints = [0,  0, 0, 0];
                    let rightCards = this.adveresaries[i].cards;

                    for (let j = 0; j < rightCards.length; j++) {
                        rightPoints[rightCards[j].suit] += this.valueToNumber(rightCards[j].value);
                    }

                    let rightMaxPoints = 0;
                    for (let i = 1; i < rightPoints.length; i++) {
                        if (rightPoints[i] > rightMaxPoints) {
                            rightMaxPoints = rightPoints[i];
                            rightMaxSuit = i;
                        }
                    }
                }
            }
        }

        // descartamos la carta minima que no sea del suit con mas puntos
        let card = -1;
        let minPoints = 12;
        for (let i = 0; i < cards.length; i++) {
            if (cards[i].suit !== maxSuit && cards[i].suit !== rightMaxSuit) {
                if (this.valueToNumber(cards[i].value) < minPoints) {
                    minPoints = this.valueToNumber(cards[i].value);
                    card = i;
                }
            }
        }

        // si todas las cartas son del mismo palo seleccionamos la ultima
        if (card === -1) {
            for (let i = 0; i < cards.length; i++) {
                if (this.valueToNumber(cards[i].value) < minPoints) {
                    minPoints = this.valueToNumber(cards[i].value);
                    card = i;
                }
            }
        }

        if (GameVars.difficulty === GameConstants.DIFFICULTY_CASUAL) {
            if (Math.random() < .25) {
                card = Math.floor(Math.random() * 4);
                maxPoints = 0;
            }
        } else if (GameVars.difficulty === GameConstants.DIFFICULTY_REGULAR) {
            if (Math.random() < .1) {
                card = Math.floor(Math.random() * 4);
                maxPoints = 0;
            }
        }

        let stopMaxPoints = GameConstants.DIFFICULTY_CASUAL ? 23 : 25;

        return {card: card, stop: maxPoints >= stopMaxPoints || GameVars.topCardDeck < 10};
    }

    public log(): void {

        console.log(this.id);
        console.log(this.adveresaries);
        // console.log(this.availableCards);
    }

    private getPointsAndSuit(): {points: number, suit: number} {

        let cards = GameVars.players[this.id].cards;

        let result1 = {points: this.valueToNumber(cards[0].value), suit: cards[0].suit};
        let result2 = {points: 0, suit: -1};
        let result3 = {points: 0, suit: -1};

        if (cards[1].suit === result1.suit) {
            result1.points += this.valueToNumber(cards[1].value);
        } else {
            result2 = {points: this.valueToNumber(cards[1].value), suit: cards[1].suit};
        }

        if (cards[2].suit === result1.suit) {
            result1.points += this.valueToNumber(cards[2].value);
        } else if (cards[2].suit === result2.suit) {
            result2.points += this.valueToNumber(cards[2].value);
        } else {
            result3 = {points: this.valueToNumber(cards[2].value), suit: cards[2].suit};
        }

        let points = result1.points;
        let suit = result1.suit;

        if (result2.points > points) {
            points = result2.points;
            suit = result2.suit;
        }

        if (result3.points > points) {
            points = result3.points;
            suit = result3.suit;
        }

        return {points: points, suit: suit};
    }

    private valueToNumber(value: string): number {

        if (value === "A") {
            return 11;
        } else if (value === "J" || value === "Q" || value === "K") {
            return 10;
        } else {
            return parseInt(value);
        }
    }
}
